var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass:
          "content-row content-align-center content-row-between font-16",
        staticStyle: { padding: ".4rem 1rem", background: "#f4f4f4" }
      },
      [
        _c("span", { staticClass: "name-icon" }, [
          _c("span", { staticStyle: { "padding-left": "1.3rem" } }, [
            _vm._v(_vm._s(_vm.$t("potentialRisk")))
          ])
        ]),
        _vm._v(" "),
        _c("span", { staticClass: "back-btn", on: { click: _vm.hideModal } }, [
          _vm._v(_vm._s(_vm.$t("goback")))
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "content-row content-row-column risk-box",
        staticStyle: { padding: ".5rem", "border-top": ".1rem solid #ededed" }
      },
      [
        _c(
          "div",
          {
            staticClass: "content-row content-row-between content-align-center",
            staticStyle: {
              padding: ".5rem .9rem",
              background: "#cbe7ff",
              "border-radius": ".3rem"
            }
          },
          [
            _c("div", {
              staticClass: "compare-img",
              attrs: { id: "modalBody" }
            }),
            _vm._v(" "),
            _c("img", {
              staticClass: "compare-img",
              attrs: { src: _vm.getRiskImg(_vm.modalInfo) }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "content-row content-align-center content-row-around",
            staticStyle: { "margin-top": "1rem", padding: "0 1rem" }
          },
          [
            _c("div", { staticClass: "content-row content-row-column" }, [
              _c(
                "div",
                {
                  staticClass:
                    "content-row content-row-between content-align-center"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "font-16",
                      staticStyle: { "margin-right": ".5rem" }
                    },
                    [_vm._v(_vm._s(_vm.modalInfo.name))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "font-14",
                      staticStyle: { color: "#8d8d8d" }
                    },
                    [_vm._v(_vm._s(_vm.modalInfo.detail))]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      class:
                        "level-box mobilerisk " +
                        _vm.getLevel(_vm.modalInfo.level).className +
                        " font-12"
                    },
                    [_vm._v(_vm._s(_vm.getLevel(_vm.modalInfo.level).des))]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "content-row content-align-end",
                  staticStyle: { width: "100%", height: "2rem" }
                },
                [
                  _c("canvas", {
                    attrs: {
                      "data-value": _vm.modalInfo.value,
                      "data-level": _vm.modalInfo.level,
                      id: "modalRiskBar"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "content-row content-row-between font-16 hmnClass",
                  staticStyle: { padding: "0 .5rem" }
                },
                [
                  _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 2)))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 1)))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$tc("levelName", 0)))])
                ]
              )
            ])
          ]
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "content-row content-row-column content-align-start",
        staticStyle: { padding: "0 .8rem" }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "content-row content-align-center font-14 risk-head auto-width",
            staticStyle: { margin: ".8rem 0" }
          },
          [
            _c("span", { staticClass: "potentialRisk-icon" }),
            _vm._v(" "),
            _c("span", { staticStyle: { color: "#fd6364" } }, [
              _vm._v(_vm._s(_vm.$t("triggersymptoms")))
            ])
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticStyle: { width: "100%", "padding-bottom": "5rem" } },
          _vm._l(_vm.modalInfo.risks, function(key) {
            return _c("div", [
              _c("div", { staticClass: "key-name font-14" }, [
                _vm._v(_vm._s(key.name))
              ]),
              _vm._v(" "),
              _c("ul", { staticClass: "potential-risk-box font-14" }, [
                _c("li", [_vm._v(_vm._s(key.des))])
              ])
            ])
          }),
          0
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "content-row content-align-center content-row-center close-box"
      },
      [_c("span", { staticClass: "close-btn", on: { click: _vm.hideModal } })]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-768f2d14", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-768f2d14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Posture_modal.vue
// module id = null
// module chunks = 